import React from 'react';
import { Check, CheckAll } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { TooltipElement } from '@soulhx/ui-common';
import { StyledBadge } from './read/StyledBadge.js';

interface IPlanItemStats {
  otVerses: number;
  ntVerses: number;
  otConditionMet: boolean;
  ntConditionMet: boolean;
  rpVariant: string;
}
export const PlanItemStats = ({ otVerses, ntVerses, otConditionMet, ntConditionMet, rpVariant }: IPlanItemStats) => {
  const { t } = useTranslation(['plan', 'translation']);

  return (
    <div className="my-1">
      {otVerses > 0 && (
        <span>
          {otConditionMet ? (
            <TooltipElement tooltip={t('plan:item.stats.longOTTT')}>
              <CheckAll />
            </TooltipElement>
          ) : (
            <TooltipElement tooltip={t('plan:item.stats.shortOTTT')}>
              <Check />
            </TooltipElement>
          )}{' '}
          {t('translation:general.otShort')}
          <StyledBadge rpVariant={rpVariant}>{otVerses}</StyledBadge>
        </span>
      )}
      {otVerses > 0 && ntVerses > 0 && <span>; </span>}
      {ntVerses > 0 && (
        <span>
          {ntConditionMet ? (
            <TooltipElement tooltip={t('plan:item.stats.longNTTT')}>
              <CheckAll />
            </TooltipElement>
          ) : (
            <TooltipElement tooltip={t('plan:item.stats.shortNTTT')}>
              <Check />
            </TooltipElement>
          )}{' '}
          {t('translation:general.ntShort')}
          <StyledBadge rpVariant={rpVariant}>{ntVerses}</StyledBadge>
        </span>
      )}
    </div>
  );
};
